export default __webpack_public_path__ + "static/prefabelementen-desktop-390f4e7f034eeadf3f3e9d3c4f7fa4ff.svg";